export const EMPTY_OPTION = {
  label: "-",
  value: "null",
  name: "-",
};
